/*
 * File: form-cron.ts
 * File Created: 2024-03-13 02:20:45
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-26 01:28:27
 * Modified By: Val Liu
 * -----
 */

import { Component, Emit } from "vue-property-decorator";
import { BaseFormComponent } from "../../core/lib/base-form-component";
import { PropInnateSync } from "@root/core/vue-props";
import {
    IFormComponentAttr,
    IFormValidateResult,
    createRequiredValidator,
} from "../../core/lib/core";
import { makeRequiredValidator } from "@root/core/decorators/make-validator";

@Component
export default class FormCron extends BaseFormComponent {
    @PropInnateSync("value", { type: String, default: undefined })
    innateValue!: string | undefined;

    @Emit("text")
    doText(value) {
        return value;
    }

    /// private helpers
    // required validation for cron
    @makeRequiredValidator({
        validator: (o) =>
            !(
                o.value === "" ||
                o.value == null ||
                (Array.isArray(o.value) && o.value.length == 0)
            ),
    })
    defaultRequired() {
        return undefined;
    }
}
